import { styled, stylePropsFont, stylePropsTextOnly, validStyles, View } from "@tamagui/core";
const TextInputComponent = styled(View, {
  tag: "input"
}, {
  accept: {
    fontFamily: "textStyle",
    fontSize: "textStyle",
    fontWeight: "textStyle",
    placeholderTextColor: "color"
  },
  isInput: !0,
  validStyles: {
    ...validStyles,
    ...stylePropsTextOnly,
    ...stylePropsFont
  }
});
export { TextInputComponent };
//# sourceMappingURL=TextInputComponent.mjs.map
